import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const IntegrationApi = createApi({
  reducerPath: "IntegrationApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_INTEGRATION_URL,
    headers: {
      "Content-Type": "application/json",
      //   "x-api-key": `AFQfF7ZEfk99kU9aquXwb1L8GLemLq5K6wmbrWuz`,
      accessToken: localStorage.getItem("accessToken") || "",
    },
  }),
  tagTypes: ["integration"],
  endpoints: (builder) => ({
    getChannelList: builder.query({
      query: () => ({ url: `/user-connection` }),
      providesTags: ["integration"],
    }),
    createConnection: builder.mutation({
      query: (body) => ({
        url: `/user-connection`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["integration"],
    }),
    checkConnection: builder.mutation({
      query: (body) => ({
        url: `/app/connection`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["integration"],
    }),
    updateConnection: builder.mutation({
      query: (payload) => ({
        url: `user-connection`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["integration"],
    }),
    realTimeConnection: builder.mutation({
      query: (body) => ({
        url: `api/v1/hubspot/contacts`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["integration"],
    }),
    deleteConnection: builder.mutation({
      query: (id) => ({
        url: `/user-connection/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["integration"],
    }),
  }),
});

export const {
  //integration
  useGetChannelListQuery,
  useCreateConnectionMutation,
  useCheckConnectionMutation,
  useUpdateConnectionMutation,
  useRealTimeConnectionMutation,
  useDeleteConnectionMutation,
} = IntegrationApi;
